import React, { useState, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Badge, FormGroup, Label } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import QwikSelect from "components/form/QwikSelect";
import { useCreateProjectMutation } from "store/features/client/clientManagementApi";
import { useGetAllDesignersQuery, useGetAllDevelopersQuery, useGetAllProjectManagersQuery } from "store/features/developer/developerManagementApi";
import { useGetAllUsersQuery } from "store/features/users/userManagementApi";


import Select from "react-select";
import { toast } from "sonner";

const CreateProjectModal = ({ isOpen, toggle, clientId, clientName }) => {
  const [createProject, { isLoading }] = useCreateProjectMutation();
  const { data: developers = [] } = useGetAllDevelopersQuery();
  const { data: designers = [] } = useGetAllDesignersQuery();
  const { data: projectManagers = [] } = useGetAllProjectManagersQuery();
  const { data: allUsers = [] } = useGetAllUsersQuery();

  const [selectedTeam, setSelectedTeam] = useState([]);
  const [selectedProjectManager, setSelectedProjectManager] = useState([]);
  const [selectedFrontendDev, setSelectedFrontendDev] = useState([]);
  const [selectedBackendDev, setSelectedBackendDev] = useState([]);
  const [selectedDesigner, setSelectedDesigner] = useState([]);
  const [selectedMarketingOfficer, setSelectedMarketingOfficer] = useState(null);


  const [projectProposal, setProjectProposal] = useState(null);
  const [contract, setContract] = useState(null);
  const [invoice1, setInvoice1] = useState(null);
  const [invoice2, setInvoice2] = useState(null);

  const developerOptions = useMemo(() => {
    return developers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [developers]);

  const projectManagersOptions = useMemo(() => {
    return projectManagers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [projectManagers]);

  const FrontendDeveloperOptions = useMemo(() => {
    return developers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [developers]);

  const BackendDeveloperOptions = useMemo(() => {
    return developers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [developers]);

  const designerOptions = useMemo(() => {
    return designers.map(dev => ({
      value: dev.id,
      label: `${dev.nickname} (${dev.role})`
    }));
  }, [designers]);

  const marketingOfficerOptions = useMemo(() => {
    return allUsers.map(u => ({
      value: u.id,
      label: `${u.nickname || u.first_name || u.username} (${u.role || 'User'})`
    }));
  }, [allUsers]);

  const handleSubmit = async (data) => {
    try {

      const paymentData = data.payment
        ? [
          {
            id: 1,
            amount: data.payment,
            date: new Date().toISOString().split('T')[0],
          },
        ]
        : [];

      // Create FormData to handle file uploads
      const formData = new FormData();

      // Append regular form data
      formData.append('name', data.name || "");
      formData.append('description', data.description || '');
      formData.append('client', clientId);
      formData.append('budget', data.budget || '0.00');

      formData.append("payment", JSON.stringify(paymentData));
      formData.append('progress', data.progress || '0');

      // formData.append('start_date', data.start_date || '');
      // formData.append('end_date', data.end_date || '');

      if (data.start_date) {
        formData.append('start_date', data.start_date || '');
      }

      if (data.end_date) {
        formData.append('end_date', data.end_date || '');
      }


      formData.append('status', data.status || 'Pending');
      formData.append('priority_status', data.priority_status || '3');

      formData.append('progress', '0');

      // Append assigned team
      // selectedTeam.forEach(dev => {
      // formData.append('assigned_team', [7]);
      // });


      selectedProjectManager.forEach(dev => {
        formData.append('assigned_project_manager', dev.value);
      });

      selectedFrontendDev.forEach(dev => {
        formData.append('assigned_frontend_dev', dev.value);
      });

      selectedBackendDev.forEach(dev => {
        formData.append('assigned_backend_dev', dev.value);
      });

      selectedDesigner.forEach(dev => {
        formData.append('assigned_designer', dev.value);
      });

      if (selectedMarketingOfficer?.value) {
        formData.append('assigned_marketing_officer', selectedMarketingOfficer.value);
        formData.append('assigned_team', selectedMarketingOfficer.value);
      }

      // Append Payment Schedules & Invoice Send Dates
      if (data.first_payment_date) formData.append('first_payment_date', data.first_payment_date);
      if (data.first_payment_amount) formData.append('first_payment_amount', data.first_payment_amount);
      if (data.first_payment_invoice_date) formData.append('first_payment_invoice_date', data.first_payment_invoice_date);
      if (data.first_payment_status) formData.append('first_payment_status', data.first_payment_status || 'Pending');

      if (data.second_payment_date) formData.append('second_payment_date', data.second_payment_date);
      if (data.second_payment_amount) formData.append('second_payment_amount', data.second_payment_amount);
      if (data.second_payment_invoice_date) formData.append('second_payment_invoice_date', data.second_payment_invoice_date);
      if (data.second_payment_status) formData.append('second_payment_status', data.second_payment_status || 'Pending');

      // Append Google Calendar Meeting
      if (data.google_calendar_meeting_link) formData.append('google_calendar_meeting_link', data.google_calendar_meeting_link);
      if (data.google_calendar_meeting_date) formData.append('google_calendar_meeting_date', data.google_calendar_meeting_date);


      // Append files if they exist
      if (projectProposal) {
        formData.append('project_proposal', projectProposal);
      }
      if (contract) {
        formData.append('contract', contract);
      }
      if (invoice1) {
        formData.append('invoice_1', invoice1);
      }
      if (invoice2) {
        formData.append('invoice_2', invoice2);
      }

      await createProject(formData).unwrap();

      // Reset form
      setSelectedTeam([]);
      setProjectProposal(null);
      setContract(null);
      setInvoice1(null);
      setInvoice2(null);
      toggle();
    } catch (error) {
      toast.error("Failed to create project");
      console.error('Project creation error:', error);
    }
  };

  const handleTeamChange = (selectedOptions) => {
    setSelectedTeam(selectedOptions || []);
  };

  const handleProjectManagerChange = (selectedOptions) => {
    setSelectedProjectManager(selectedOptions || []);
  };

  const handleFrontendDevChange = (selectedOptions) => {
    setSelectedFrontendDev(selectedOptions || []);
  };

  const handleBackendDevChange = (selectedOptions) => {
    setSelectedBackendDev(selectedOptions || []);
  };

  const handleDesignerChange = (selectedOptions) => {
    setSelectedDesigner(selectedOptions || []);
  };

  const removeTeamMember = (developerId) => {
    setSelectedTeam(prev => prev.filter(dev => dev.value !== developerId));
  };

  const handleFileChange = (setter, event) => {
    const file = event.target.files[0];
    setter(file);
  };

  const getFileName = (file) => {
    return file ? file.name : 'No file chosen';
  };

  const handleModalClose = () => {
    // Reset all states when modal closes
    setSelectedTeam([]);
    setProjectProposal(null);
    setContract(null);
    setInvoice1(null);
    setInvoice2(null);
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleModalClose} size="lg">
      <ModalHeader toggle={handleModalClose}>Create Project for {clientName}</ModalHeader>
      <QwikForm onSubmit={handleSubmit}>
        <ModalBody>
          <Row>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="name"
                  label="Project Name"
                  placeholder="Enter project name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="budget"
                  label="Budget"
                  placeholder="Enter budget"
                  type="number"
                  step="0.01"
                  className="form-control"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="description"
                  label="Description"
                  placeholder="Enter project description"
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="payment"
                  label="Payment"
                  placeholder="Enter payment"
                  type="number"
                  step="0.01"
                  className="form-control"
                />
              </div>
            </Col>

            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="progress"
                  label="Progress (%)"
                  type="number"
                  min="0"
                  max="100"
                  className="form-control"
                />
              </div>
            </Col>



            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="start_date"
                  label="Start Date"
                  type="date"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikInput
                  name="end_date"
                  label="End Date"
                  type="date"
                  className="form-control"
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikSelect
                  name="status"
                  label="Status"
                  options={[
                    { value: "Pending", label: "Pending" },
                    { value: "In Progress", label: "In Progress" },
                    { value: "Completed", label: "Completed" },
                    { value: "On Hold", label: "On Hold" }
                  ]}
                />
              </div>
            </Col>
            <Col lg={6}>
              <div className="mb-3">
                <QwikSelect
                  name="priority_status"
                  label="Priority status"
                  options={[
                    { value: "1", label: "High" },
                    { value: "2", label: "Medium" },
                    { value: "3", label: "Low" },
                  ]}
                />
              </div>
            </Col>

            {/* Payment Schedule & Invoice Dates */}
            <Col lg={12}>
              <div className="p-3 mb-3 border rounded bg-light">
                <h6 className="fw-bold text-primary mb-3">
                  <i className="fas fa-file-invoice-dollar me-2"></i>1st Payment & Invoice Schedule
                </h6>
                <Row>
                  <Col md={3}>
                    <QwikInput name="first_payment_date" label="1st Payment Date" type="date" />
                  </Col>
                  <Col md={3}>
                    <QwikInput name="first_payment_amount" label="1st Payment Amount (৳)" type="number" placeholder="0.00" />
                  </Col>
                  <Col md={3}>
                    <QwikInput name="first_payment_invoice_date" label="Invoice Send Date" type="date" />
                  </Col>
                  <Col md={3}>
                    <QwikSelect
                      name="first_payment_status"
                      label="Payment Status"
                      options={[
                        { value: "Pending", label: "Pending" },
                        { value: "Invoice Sent", label: "Invoice Sent" },
                        { value: "Paid", label: "Paid" }
                      ]}
                    />
                  </Col>
                </Row>
              </div>
            </Col>

            <Col lg={12}>
              <div className="p-3 mb-3 border rounded bg-light">
                <h6 className="fw-bold text-primary mb-3">
                  <i className="fas fa-file-invoice-dollar me-2"></i>2nd Payment & Invoice Schedule
                </h6>
                <Row>
                  <Col md={3}>
                    <QwikInput name="second_payment_date" label="2nd Payment Date" type="date" />
                  </Col>
                  <Col md={3}>
                    <QwikInput name="second_payment_amount" label="2nd Payment Amount (৳)" type="number" placeholder="0.00" />
                  </Col>
                  <Col md={3}>
                    <QwikInput name="second_payment_invoice_date" label="Invoice Send Date" type="date" />
                  </Col>
                  <Col md={3}>
                    <QwikSelect
                      name="second_payment_status"
                      label="Payment Status"
                      options={[
                        { value: "Pending", label: "Pending" },
                        { value: "Invoice Sent", label: "Invoice Sent" },
                        { value: "Paid", label: "Paid" }
                      ]}
                    />
                  </Col>
                </Row>
              </div>
            </Col>

            {/* Google Calendar & Meeting Info */}
            <Col lg={12}>
              <div className="p-3 mb-3 border rounded bg-light">
                <h6 className="fw-bold text-success mb-3">
                  <i className="fab fa-google me-2"></i>Google Calendar & Meeting Setup
                </h6>
                <Row>
                  <Col md={6}>
                    <QwikInput name="google_calendar_meeting_date" label="Scheduled Meeting Date & Time" type="datetime-local" />
                  </Col>
                  <Col md={6}>
                    <QwikInput name="google_calendar_meeting_link" label="Google Calendar / Meet Link" type="text" placeholder="https://meet.google.com/..." />
                  </Col>
                </Row>
              </div>
            </Col>

            {/* File Upload Fields */}
            <Col lg={6}>
              <FormGroup>
                <Label for="project_proposal" className="form-label">
                  Project Proposal
                </Label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="project_proposal"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={(e) => handleFileChange(setProjectProposal, e)}
                  />
                  <label className="custom-file-label" htmlFor="project_proposal">
                    {getFileName(projectProposal)}
                  </label>
                </div>
                {/* <small className="form-text text-muted">
                  Upload project proposal (PDF, DOC, JPG, PNG)
                </small> */}
              </FormGroup>
            </Col>

            <Col lg={6}>
              <FormGroup>
                <Label for="contract" className="form-label">
                  Contract
                </Label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="contract"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={(e) => handleFileChange(setContract, e)}
                  />
                  <label className="custom-file-label" htmlFor="contract">
                    {getFileName(contract)}
                  </label>
                </div>
                {/* <small className="form-text text-muted">
                  Upload contract document (PDF, DOC, JPG, PNG)
                </small> */}
              </FormGroup>
            </Col>

            <Col lg={6}>
              <FormGroup>
                <Label for="invoice_1" className="form-label">
                  Invoice 1
                </Label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="invoice_1"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={(e) => handleFileChange(setInvoice1, e)}
                  />
                  <label className="custom-file-label" htmlFor="invoice_1">
                    {getFileName(invoice1)}
                  </label>
                </div>
                {/* <small className="form-text text-muted">
                  Upload first invoice (PDF, DOC, JPG, PNG)
                </small> */}
              </FormGroup>
            </Col>

            <Col lg={6}>
              <FormGroup>
                <Label for="invoice_2" className="form-label">
                  Invoice 2
                </Label>
                <div className="custom-file">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="invoice_2"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={(e) => handleFileChange(setInvoice2, e)}
                  />
                  <label className="custom-file-label" htmlFor="invoice_2">
                    {getFileName(invoice2)}
                  </label>
                </div>
                {/* <small className="form-text text-muted">
                  Upload second invoice (PDF, DOC, JPG, PNG)
                </small> */}
              </FormGroup>
            </Col>

            {/* <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Assign Team</label>
                <Select
                  options={developerOptions}
                  isMulti
                  value={selectedTeam}
                  onChange={handleTeamChange}
                  placeholder="Search developers by name or email..."
                  classNamePrefix="select2-selection"
                  required
                />
              </div>

              {selectedTeam.length > 0 && (
                <div className="mb-3">
                  <label className="form-label">Selected Team Members:</label>
                  <div className="d-flex flex-wrap gap-2">
                    {selectedTeam.map(dev => (
                      <Badge key={dev.value} color="primary" className="p-2 d-flex align-items-center">
                        {dev.label}
                        <button
                          type="button"
                          className="btn-close btn-close-white ms-2"
                          style={{ fontSize: '10px' }}
                          onClick={() => removeTeamMember(dev.value)}
                        />
                      </Badge>
                    ))}
                  </div>
                </div>
              )}
            </Col> */}

            <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Assign Project Manager</label>
                <Select
                  options={projectManagersOptions}
                  isMulti
                  value={selectedProjectManager}
                  onChange={handleProjectManagerChange}
                  placeholder="Search project managers by name or email..."
                  classNamePrefix="select2-selection"
                />
              </div>


            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Assign Frontend Developers</label>
                <Select
                  options={FrontendDeveloperOptions}
                  isMulti
                  value={selectedFrontendDev}
                  onChange={handleFrontendDevChange}
                  placeholder="Search frontend developers by name or email..."
                  classNamePrefix="select2-selection"
                />
              </div>


            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Assign Backend Developers</label>
                <Select
                  options={BackendDeveloperOptions}
                  isMulti
                  value={selectedBackendDev}
                  onChange={handleBackendDevChange}
                  placeholder="Search backend developers by name or email..."
                  classNamePrefix="select2-selection"
                />
              </div>


            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <label className="form-label">Assign Designer</label>
                <Select
                  options={designerOptions}
                  isMulti
                  value={selectedDesigner}
                  onChange={handleDesignerChange}
                  placeholder="Search designers by name or email..."
                  classNamePrefix="select2-selection"
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <label className="form-label fw-semibold text-primary">Assign Marketing Officer</label>
                <Select
                  options={marketingOfficerOptions}
                  value={selectedMarketingOfficer}
                  onChange={setSelectedMarketingOfficer}
                  placeholder="Select Marketing Officer..."
                  classNamePrefix="select2-selection"
                  isClearable
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Creating..." : "Create Project"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default CreateProjectModal;